define('views/modules/conversation/conversation',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'moment',
    'utils',
    'jquery-easing',
    // services
    'services/user',
    'services/i18n',
    'services/events/conversation-events',
    //Collections and models
    'collections/conversation/messages',
    'models/conversation/message',
    // views
    'src/views/responsive-view',
    'views/parts/form/chatbox',
    'views/modules/conversation/message/message-list',
    'views/modules/conversation/message/message-list-item',
    'views/parts/form/choices',
    // Templates
    'text!templates/modules/conversation/conversation.html',
], function(
    // libs
    $, _, Backbone, Mustache, moment, U, JQueryEasing,
    // services
    User,
    i18n,
    ConversationEvents,
    // Collections and models
    CMessage,
    MMessage,
    // views
    VResponsive,
    VChatBox,
    VMessageList,
    VMessageListItem,
    // VMessageFilter,
    VChoices,
    // templates
    TConversation
) {

    var VConversation = VResponsive.extend({
        template: TConversation,
        // TODO Change Conversation and name after with the true model
        title: function() {
            var model = this.model,
                name = model.getUser() ? model.getDisplayName() : this.profile.get('name'),
                translated = i18n.t('conversation:Conversation') + ' <span class="sl-icon-arrow-right"></span> {{name}}';

            return Mustache.render(translated, Mustache.getContext({
                name: name
            }));
        },
        subtitle: function() { return i18n.t('conversation:Direct Messaging'); },
        skipTranslation: true,

        events: {
            "click #sendMessage": "onSendMessage",
        },
        regions: {
            list: ".message-list",
            input: ".message-input",
            chatbox: ".message-chatbox",
            noMessages: ".no-messages",
            filter: ".message-filter"
        },

        initialize: function(opt) {
            opt = opt || {};

            var messageFilter = this.messageFilter = this.getMessageFilter();
            window.conversationContext = this;

            _.extend(this, {
                profile: opt.profile,
                url: opt.url,
                group: opt.group,
                role: opt.role,
                message: new MMessage({ user: User.id }),
                collection: new CMessage(null, { conversation: this.model }),
            });

            var choicesFilter = [
                { label: 'conversation:All messages', value: 'message' },
                { label: 'questionnaire:Questionnaire Only', value: 'questionnaire' },
                { label: 'calendar:Feedback Only', value: 'feedback' },
            ];

            var model = this.model,
                collection = this.collection,
                view = this.view = {
                    list: new VMessageList({
                        collection: collection,
                        conversation: model,
                        group: this.group,
                        profile: this.profile,
                        role: this.role,
                        url: this.url,
                        top: true,
                        filter: messageFilter,
                        button: {
                            label: 'conversation:Show more messages',
                            icon: 'sl-icon-arrow-up'
                        },
                    }),
                    filter: new VChoices({
                        choices: choicesFilter,
                        model: new Backbone.Model({
                            filter: messageFilter,
                        }),
                        attribute: 'filter',
                        radio: true,
                        styleButton: true,
                        onChange: this.onFilterChange,
                        context: this,
                    }),
                    chatbox: new VChatBox({
                        label: 'Send',
                        icon: 'sl-icon-check',
                        model: this.message,
                        attribute: 'content',
                        callback: this.onSendMessage,
                        context: this,
                        group: this.group,
                        profile: this.profile,
                    }),
                };

            this.listenTo(collection, {
                    'reset': this.onCollectionReset,
                    'feedback:reply': this.onFeedbackReply,
                    'list:loadMoreCompleted': this.onCollectionUpdate,
                })
                .listenTo(model, {
                    "sync": this.onModelSync,
                    "model:reset": this.onModelReset
                })
                .listenTo(view.chatbox, {
                    "cancel:reply": this.onCancelReply
                });
        },

        render: function() {
            this.initListener();
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.model.toJSON())));

            this.generateZones();

            var view = this.view,
                zone = this.zone;

            this.assign(view.chatbox, zone.$chatbox)
                .assign(view.filter, zone.$filter)
                .assign(view.list, zone.$list);


            this.toggleNoMessages();
            this.showMessageBasedOnFilter();

            this.model.set("message", '');
            this.view.chatbox.setValue('');

            return this;
        },

        initInterval: function() {
            if (this.interval) window.clearInterval(this.interval);
            this.interval = window.setInterval(function() {
                if (Backbone.history.getFragment().includes('messages')) {
                    this.getLastMessages();
                } else {
                    window.clearInterval(this.interval);
                }
            }.bind(this), 10000);
        },

        getLastMessages: function() {
            this.model.firstFetch({
                data: { limit: 10 },
                silent: true,
                success: this.onFetchSuccess.bind(this)
            });
        },

        onFetchSuccess: function(lastMessages) {
            if (lastMessages.getMessages().length <= 0) return;

            var mostRecentMessageId = lastMessages.getMostRecentMessage()._id;
            if (mostRecentMessageId === this.lastMessageId) return;

            var newMessages = this.getNewMessages(lastMessages);
            this.collection.add(newMessages);
            this.fadeInNewMessages(newMessages);
            this.lastMessageId = mostRecentMessageId;
            this.scrollToMostRecentMessage();
        },

        getNewMessages: function(lastMessages) {
            var newMessages = [];
            var index = _.findIndex(lastMessages.getMessages(), { _id: this.lastMessageId });
            var messages = lastMessages.getMessages();
            for (var i = (index - 1); i >= 0; i--) {
                newMessages.push(messages[i]);
            }
            return newMessages;
        },

        fadeInNewMessages: function(messages) {
            var divs = Backbone.$('.message-list .list-content .list-items > div').slice(-messages.length);
            divs.each(function (index, element) {
                element.classList.add('new');
            });
        },

        scrollToMostRecentMessage: function() {
            var lastMessagePosition = Backbone.$('.message-list .list-content .list-items div:last').offset().top;
            this.pageElement.scrollBy(0, lastMessagePosition);
        },

        initListener: function() {
            this.stopListeningTo(ConversationEvents);
            this.listenTo(ConversationEvents, {
                'feedback:sent': this.onFeedbackSent
            });
            return this;
        },

        changeUrl: function() {
            var model = this.model;
            var url = Mustache.render(this.url.conversation, {
                userId: this.group.isSupervisor() ? this.profile.id : 'me',
                groupId: this.group.id,
                conversationId: model.id // to temporarily handle both supervisor/member urls
            });

            Backbone.history.navigate(url, { replace: true });
        },

        toggleNoMessages: function() {
            if (!this.zone) return;
            this.zone.$noMessages.toggle(!Boolean(this.collection.length));
        },

        removeActiveClass: function() {
            this.$el.find('.message-box').removeClass('active dark-color');
        },

        isCalendarUrl: function() {
            return Backbone.history.getFragment().indexOf('calendar') > -1;
        },

        initTweenDelay: function(context) {
            if ($('.message-list').is(':visible')) {
                context.tweenTimeOut = setTimeout(context.startTween, 200);
            } else {
                if (context.initTweenTimeout < 40) { //Stop after 2  seconds (50 ms * 40)
                    context.initTweenTimeout += 1;
                    setTimeout(function() { context.initTweenDelay(context); }, 50);
                }
            }
        },

        startTween: function() {
            var parent = window.conversationContext;

            if (parent === undefined) { return; }

            parent.pageElement = document.getElementById("page");
            parent.tween = {
                intervalValue: 13,
                currentTime: 0,
                totalTime: 1200,
                previousScrollValue: parent.pageElement.scrollTop,
                startPosition: parent.pageElement.scrollTop,
                scrollHeight: parent.pageElement.scrollHeight - window.innerHeight - parent.pageElement.scrollTop + 50,
                isTweening: false,
            };

            if (parent.tween.scrollHeight <= 50 || parent.tween.isTweening === true) { return; }

            if (parent.tweenInterval) { clearInterval(parent.tweenInterval); }

            parent.tween.isTweening = true;
            parent.tweenInterval = setInterval(function() {
                parent.tween.currentTime += parent.tween.intervalValue;

                if (parent.tween.currentTime >= parent.tween.totalTime) {
                    clearInterval(parent.tweenInterval);
                    parent.tween.isTweening = false;
                    return;
                }

                var scrollValue = $.easing.easeOutQuart(
                    null,
                    parent.tween.currentTime,
                    parent.tween.startPosition,
                    parent.tween.scrollHeight,
                    parent.tween.totalTime
                );

                parent.scrollDown(scrollValue);
            }, parent.tween.intervalValue);
        },

        scrollDown: function(scrollValue) {
            var parent = window.conversationContext;
            parent.scrollDelta = scrollValue - parent.tween.previousScrollValue;

            parent.pageElement.scrollBy(0, parent.scrollDelta);

            parent.tween.previousScrollValue = scrollValue;
        },

        ////////////
        // events //
        ////////////
        onSendMessage: function(messageModel, value) {
            var message = this.message,
                model = this.model,
                attributes = {
                    message: value,
                    attachments: this.view.chatbox.getFile()
                };

            if (this.replyToMessage) {
                model.save(_.extend(attributes, { type: 'feedback' }), {
                    type: 'POST',
                    silent: true,
                    parentMessageId: this.replyToMessage.id,
                    success: this.onFeedbackReplySuccess,
                    context: this
                });

            } else {

                model.setUser(this.profile.id);

                if (model.isNew()) {
                    // message field is not permitted on create
                    attributes = _.extend(attributes, _.omit(model.attributes, 'message'));
                }

                model.save(attributes, {
                    type: 'POST',
                    silent: true,
                    success: this.onSendSuccess,
                    error: this.onSendError,
                    context: this
                });
            }

            message.set('user', User.id);
        },

        onModelSync: function(model, response, options) {
            if (options.silent) return;

            if(model.getMessages().length > 0) this.lastMessageId = model.getMessages()[0]._id;

            var collection = this.collection;

            if (!this.isCalendarUrl()) {
                this.changeUrl();
            }

            collection.setUsers(model.getComputedUsers());
            collection.reset(model.getMessages());

            this.model.resetDistantMemberId();

            if (this.tweenInterval) {
                clearInterval(this.tweenInterval);
            }
            this.initTweenTimeout = 0;
            this.initTweenDelay(this);
            this.initInterval();
        },

        onModelReset: function(model) {
            model.setUser(this.profile.id);
            this.collection.reset();

            this.showMessageBasedOnFilter();
        },

        onCollectionReset: function() {
            this.toggleNoMessages();
            this.showMessageBasedOnFilter();
        },

        onCollectionUpdate: function(previousHeight) {
            var pageHeight = document.getElementById("page").scrollHeight;

            var pos = pageHeight - previousHeight;
            this.pageElement.scrollBy(0, pos);
        },

        onSendSuccess: function(model) {
            this.lastMessageId = _.last(model.getMessages())._id;
            var collection = this.collection;
            collection.setUsers(model.getComputedUsers());
            collection.add(model.getLastMessage());
            this.toggleNoMessages();
            this.message.reset();
            ConversationEvents.messageAjaxEnd();
            this.scrollToMostRecentMessage();
        },

        onSendError: function(model, response, options) {
            ConversationEvents.messageAjaxEnd();
        },

        onCancelReply: function() {
            this.replyToMessage = null;
            this.removeActiveClass();
        },

        onFeedbackReply: function(model) {
            this.replyToMessage = this.collection.get(model);
            this.view.chatbox.toggleMessageReply(true);
        },

        onFeedbackReplySuccess: function(model) {
            this.model.resetParentMessageId(); //
            this.removeActiveClass();
            this.view.chatbox.toggleMessageReply(false);
            this.collection.get(this.replyToMessage).trigger('reply:success', model);
            this.replyToMessage = null;
            ConversationEvents.messageAjaxEnd();
        },

        onFeedbackSent: function(collection) {
            // retrieving current conversation in conversations collection
            var conversation = collection.get(this.model);
            if (conversation) {
                this.collection.add(conversation.getLastMessage());
            }
        },

        onFilterChange: function(model, value) {
            this.setMessageFilter(value);
            this.showMessageBasedOnFilter();
        },

        onResize: function(e, width) {
            if (this.zone.$chatbox) {
                this.zone.$chatbox.width(width);
            }
        },

        onDisable: function() {
            this.stopListeningTo(ConversationEvents);
        },

        // Function //
        showMessageBasedOnFilter: function() {
            var filter = this.getMessageFilter();
            if (filter === "message") {
                Backbone.$('.message-list').find('.message-box').removeClass('hidden');
            } else {
                Backbone.$('.message-list').find('.message-box').addClass('hidden');
                Backbone.$('.message-list').find('.message-' + this.messageFilter).removeClass('hidden');
            }
        },

        getMessageFilter: function() {
            if (!this.messageFilter) this.setMessageFilter('message');
            return this.messageFilter;
        },

        setMessageFilter: function(value) {
            this.messageFilter = value;
        }

    });

    return VConversation;
});

